<template>
  <div class="map-wrap" style="width: 100%; height: 100%; position: absolute;">
    <div id="map" class="map" ref="mapContainer" style="height: 100%;"></div>
    <!-- <button role="button">prev</button> -->
  </div>
</template>

<style>
.ol-zoom {
  right: 0.5em !important;
  left: auto !important;
}
@media (max-width: 767px) {
  .ol-zoom {
    right: 0.5em !important;
    left: auto !important;
    top: calc(50% - 23px) !important;
  }
}
</style>
<script>

import 'ol/ol.css';
//import { apply } from 'ol-mapbox-style';
import Map from 'ol/Map';
import {easeIn} from 'ol/easing';
import View from 'ol/View';
import {Select, defaults as defaultsInteraction} from "ol/interaction";
import {getCenter} from "ol/extent";
//import Click from "ol/events/condition";
import {Attribution} from "ol/control";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {defaults} from "ol/control";
import {fromLonLat, transform} from "ol/proj";
import {GeoJSON} from "ol/format";
import {Style, Fill, Stroke, Icon, Text} from "ol/style";
import {Point} from "ol/geom";
import {Feature} from "ol";
import TileJSON from "ol/source/TileJSON";
import TileLayer from "ol/layer/Tile";



const key = process.env.VUE_APP_MAPTILER_API_KEY;
const attribution = new Attribution({
  collapsible: false,
});
var projection = 'EPSG:3857';
//const styleJson = `https://api.maptiler.com/maps/8f8ac384-8703-4579-8736-eeb84a53bea7/style.json?key=${key}`;
var map = null;
var selectedSquareId = null;



var colors = [
  'rgba(255, 188, 31, 0.12)',
  'rgba(255, 166, 30, 0.24)',
  'rgba(255, 146, 29, 0.36)',
  'rgba(255, 127, 28, 0.48)',
  'rgba(255, 103, 27, 0.6)',
];

var textScores = [
  "1",
  "2",
  "3",
  "4",
  "5",
];

var selected = new Style({
  fill: new Fill({
    color: '#eeeeee',
  }),
  stroke: new Stroke({
    color: 'rgba(255, 255, 255, 0.7)',
    width: 2,
  }),
});

const selectSingleClick = function(mapWidget) {

  return new Select({
    condition:function(event){
      return event.type == 'singleclick';
    },
    style: mapWidget.selectStyle,
    filter: function(feature){
      return 'values_' in feature && 'id' in feature.values_
    }//filtering speeds up the process
  });
}

var selectInteraction = null;

// Symuluj zdarzenie kliknięcia w punkt na mapie (x, y)
function simulateClickEvent(x, y) {

  // Pobierz obiekt z mapy w danym punkcie
  var features = map.getFeaturesAtPixel([x, y], {
    layerFilter: function(layer) {
      return layer.values_.name === 'grid-layer'; // Filtrowanie warstw, jeśli potrzebne
    }
  });

  if (features.length > 0) {

    // Znaleziono obiekty - wywołaj zdarzenie wyboru
    selectInteraction.getFeatures().clear(); // Wyczyść poprzednie zaznaczenie
    selectInteraction.getFeatures().extend(features); // Zaznacz znalezione obiekty
    // Tutaj możesz dodać obsługę zdarzenia zaznaczenia, jeśli chcesz
  } else {
    // Brak obiektów - wyczyść zaznaczenie
    selectInteraction.getFeatures().clear();
  }
}


const iconStyle = new Style({
  image: new Icon({
    anchor: [0.5, 40],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: require('@/assets/dist/img/pin_g.png'),
  }),
  zIndex: 10000,
});

const iconStyleRed = new Style({
  image: new Icon({
    anchor: [0.5, 40],
    anchorXUnits: 'fraction',
    anchorYUnits: 'pixels',
    src: require('@/assets/dist/img/pin.png'),
  }),
  zIndex: 10000,
});

// var textStyle = new Style({
//   text: new Text({
//     font: `${this.fontSize} "Mark Offc For MC"`,
//     fill: new Fill({ color: '#000' }),
//     text: null,
//     overflow: true,
//     placement: 'point'
//   }),
// })


var source;
var layer;
var labelSource;
var labelLayer;
var realEstateLayer;
var mapLoadedHandlerInterval = false;
//var featureSelectedAtStart = null;

const sourceTileJSON = new TileJSON({
  url: `https://api.maptiler.com/maps/8f8ac384-8703-4579-8736-eeb84a53bea7/tiles.json?key=${key}`, // source URL
  tileSize: 512,
  crossOrigin: 'anonymous'
});

var MapWidget = {
  name: 'MapWidget',
  props: {
    pinsShouldBeShown: {
      type: Boolean,
      default: true
    },
    scoringShouldBeShown: {
      type: Boolean,
      default: true
    },
    selcectSquare: {
      type: Object,
      default: {
        event:'next',
        id:0
      }
    }
  },
  data() {
    return {
      mapLoaded: false,
      features: [],
      featuresStylesIndexes: [],
      //featureSelectedAtStart: null,
      geoJson: null,
      city: null,
      address: null,
      selectedFeature: null,
      scoring: [],
      squaresLoaded: false,
      squares: null,
      offersLoaded: false,
      showScoring: false,
      styles: [
        {
          fill: new Fill({
            color: colors[0]
          }),
        },
        {
          fill: new Fill({
            color: colors[1]
          }),
        },
        {
          fill: new Fill({
            color: colors[2]
          }),
        },
        {
          fill: new Fill({
            color: colors[3]
          }),
        },
        {
          fill: new Fill({
            color: colors[4]
          }),
        },
      ],
      fontSize: 18,
      stylesLabels: [
        {
          text: new Text({
            font: `${this.fontSize} "Mark Offc For MC"`,
            fill: new Fill({ color: '#000' }),
            text: textScores[0],
            overflow: true,
            placement: 'point'
          }),
        },
        {
          text: new Text({
            font: `${this.fontSize} "Mark Offc For MC"`,
            fill: new Fill({ color: '#000' }),
            text: textScores[1],
            overflow: true,
            placement: 'point'
          }),
        },
        {
          text: new Text({
            font: `${this.fontSize} "Mark Offc For MC"`,
            fill: new Fill({ color: '#000' }),
            text: textScores[2],
            overflow: true,
            placement: 'point'
          }),
        },
        {
          text: new Text({
            font: `${this.fontSize} "Mark Offc For MC"`,
            fill: new Fill({ color: '#000' }),
            text: textScores[3],
            overflow: true,
            placement: 'point'
          }),
        },
        {
          text: new Text({
            font: `${this.fontSize} "Mark Offc For MC"`,
            fill: new Fill({ color: '#000' }),
            text: textScores[4],
            overflow: true,
            placement: 'point'
          }),
        },
      ],
      textStyle: new Style({
        text: new Text({
          font: `${this.fontSize} "Mark Offc For MC"`,
          fill: new Fill({ color: '#000' }),
          text: null,
          overflow: true,
          placement: 'point'
        }),
      }),
      stylesObjects: [],
      stylesLabelsObjects: [],
      needToReselect: false,

      tempSquareId: null,
      maxSquareId: 100000,
    }
  },
  mounted() {
    this.initWithMapReset();
    // map.on('moveend', this.zoomChangeHandler);
    // map.on('change:resolution', this.zoomChangeHandler);
  },
  watch: {
    selcectSquare: function(val) {
      console.log('map selcectSquare', val, val.id);
      
      if (val.event == 'prev') {
        this.selectPrevSquare();
      }
      if (val.event == 'next') {
        this.selectNextSquare()
      }
    },
    pinsShouldBeShown: function (val) {
      if(val) {
        map.addLayer(realEstateLayer);
      } else {
        map.removeLayer(realEstateLayer);
      }
    },
    scoringShouldBeShown: function (val) {
      this.showScoring = val;
      if(val) {
        map.addLayer(labelLayer);
      } else {
        map.removeLayer(labelLayer);
      }
    },
    'this.$store.state.quiz.industry': function () {
      //this.loadSquares();
    }
  },
  methods: {
    initWithMapReset() {
      map = null;
      this.init();
    },
    init() {
      selectedSquareId = null;
      this.stylesObjects = [];
      this.stylesLabelsObjects = [];

      for(var idx in this.styles) {
        this.stylesObjects.push(new Style(this.styles[idx]));
      }
      for(var sidx in this.stylesLabels) {
        this.stylesLabelsObjects.push(new Style(this.stylesLabels[sidx]));
      }

      var This = this;
      //setting up city selected in quiz
      if(this.$store.state.quiz.city != null) {
        this.city = this.$store.state.quiz.city;
      }

      this.address = this.$store.state.quiz.address;

      var interactions = defaultsInteraction({altShiftDragRotate:false, pinchRotate:false});
      if(map == null) {
        map = new Map({
          layers: [
            new TileLayer({
              source: sourceTileJSON
            }),
          ],
          target: 'map',
          controls: defaults({attribution: false}).extend([attribution]),
          view: new View({
            constrainResolution: true,
            //center: fromLonLat([21.017532, 52.237049]),
            zoom: 12,
            minZoom: 11,
            maxZoom: 18,
            center: transform([21.017532, 52.237049], 'EPSG:4326', projection),

          }),
          interactions: interactions,
        });

        map.on('singleclick', function (evt) {

          var markerHasBeenClicked = false;
          map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
            if (layer.values_.name === 'real-estates') {
              markerHasBeenClicked = true;
            }
          });
          if (markerHasBeenClicked == false) {
            map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {

              if (layer.values_.name !== 'grid-layer') return;
              if (feature) {

                map.getView().animate({
                  center: evt.coordinate,
                  duration: 500,
                  zoom: This.isMobile() ? 14 : 16,
                  easing: easeIn
                }, function () {
                  setTimeout(() => {
                    var center = map.getView().getCenter();
                    map.getView().setCenter([center[0] + 0.000000001, center[1] + 0.000000001]);//fix for refresh map due to display old square selection
                  }, 500);

                });
              }

            });
          } else {
            const coordinate = evt.coordinate;
            var firstItem = null;
            map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {

              if (firstItem != null) return;//only first marker at this point

              if (layer.values_.name !== 'real-estates') return;

              if (feature && 'isOffer' in feature.values_) {
                This.$emit('offer-selected', feature.values_);

                firstItem = feature;
                //map.getView().setCenter(coordinate);
                map.getView().animate({
                  center: coordinate,
                  duration: 500,
                  zoom: This.isMobile() ? 14 : 16,
                  easing: easeIn
                });
              }

            });
            This.reportMarkerClick()
          }


        });

        //obsługa zaznaczenia po kliku
        map.addInteraction(selectSingleClick(this));
        //apply(map, styleJson);

        //obsługa manualnego zaznaczenia bez kliku przy załadowaniu mapy
        selectInteraction = map.getInteractions().getArray().find(function (interaction) {
          return interaction instanceof Select;
        });
      }

      if(this.city != null) {
        if(this.address == null) {//if address is not set, center map to city center
          this.showCity();
        }
        this.loadSquares();
        this.loadScoreLabels();
      }

      if(this.address != null) {

        map.on('loadend', function() {

          This.onMapLoadHandler();
        });


        map.getView().setCenter(transform([this.address.center[0], this.address.center[1]], 'EPSG:4326', projection));
        map.getView().setZoom(This.isMobile() ? 14 : 16);

        mapLoadedHandlerInterval = setInterval(function(MapWidget) {
          MapWidget.onMapLoadHandler();
        }, 1000, This);
      }

      map.on('pointermove', function(e){
        var pixel = map.getEventPixel(e.originalEvent);
        var hit = map.hasFeatureAtPixel(pixel);
        map.getViewport().style.cursor = hit ? 'pointer' : '';
      });
    },
    setNeedToReselect(val) {
      this.needToReselect = val;
    },
    onMapLoadHandler() {
      //loadend
      var This = this;

      if(This.mapLoaded == true && This.squaresLoaded == true) return;

      var mapSize = map.getSize();

      //TODO need to set selection for square if new category was loaded
      selectedSquareId;

      map.forEachFeatureAtPixel([mapSize[0]/2, mapSize[1]/2], function(feature, layer) {
        if(layer.values_.name !== 'grid-layer') return;
        if (feature) {

          clearInterval(mapLoadedHandlerInterval);
          var featureExtent = feature.getGeometry().getExtent();
          var featureCenter = getCenter(featureExtent);
          map.getView().setCenter([featureCenter[0], featureCenter[1]]);//centering to center of selected square


          selectedSquareId = feature.values_.id;
          //This.selectStyle(feature);//this shows real estate offers
          This.$emit('square-selected', feature.values_);
          //symulowanie kliku po załadowaniu się mapy
          simulateClickEvent(mapSize[0]/2, mapSize[1]/2);

          This.mapLoaded = true;

        }
      });


    },
    getScoring(categoryId) {
      return this.$store.dispatch('fetchScoring', {
        cityId: this.$store.state.quiz.city.id,
        categoryId: categoryId,
      }).then((response) => {
        this.scoring = response;
      });
    },
    getRealEstates(squareId) {

      this.$store.dispatch('fetchSquareOffers', {
          'squareId': squareId,
          'budget': this.$store.state.quiz.budget,
          'noBudgetYet': this.$store.state.quiz.noBudgetYet,
          'buy': this.$store.state.quiz.buy,
        }).then((response) => {
          //need to send offers to sidebar via results view
          this.$emit('offersLoaded', response);


          map.removeLayer(realEstateLayer);
          var featrueList = [];
          for(var idx in response) {


            var elem = new Feature({
              isOffer: true,
              geometry: new Point(fromLonLat([response[idx].lng, response[idx].lat])),
              offer: response[idx]
            });

            elem.setStyle(this.getMarkerIconStyle(response[idx]));
            featrueList.push(elem);
          }

          realEstateLayer = new VectorLayer({
            name: 'real-estates',
            source: new VectorSource({
              features: featrueList
            }),
            zIndex: 10000,
          });

          if(this.$props['pinsShouldBeShown'])
            map.addLayer(realEstateLayer);

          this.offersLoaded = true;

          var zIndex = 1;
          map.getLayers().forEach(function(layer) {
            layer.setZIndex(zIndex);
          });
          realEstateLayer.setZIndex(10001);

      });
    },
    getMarkerIconStyle(offer) {

      if(this.$store.state.quiz.noBudgetYet == false && this.$store.state.quiz.buy == false) {


        if(offer.price != null && offer.price <= this.$store.state.quiz.budget) {
          return iconStyleRed;
        } else {
          return iconStyle;
        }
      }

      return iconStyle;
    },
    selectStyle(feature) {

      selected.getFill().setColor(this.featuresStylesIndexes[feature.values_.externalId] == undefined ? colors[0] : colors[this.featuresStylesIndexes[feature.values_.externalId]]);
      //selected.getFill().setColor('rgba(255, 103, 27, 0.5)');
      selected.getStroke()
          .setColor('rgba(255, 103, 27, 1)');
      selected.getStroke()
          .setWidth(2);

      // if (this.showScoring) {
      //   selected.getText().setText(this.featuresStylesIndexes[feature.values_.externalId] == undefined ? null : textScores[this.featuresStylesIndexes[feature.values_.externalId]]);
      // } else {
      //   selected.getText().setText(null)
      // }

      //this.$emit('squareSelected', feature.values_);
      this.$emit('square-selected', feature.values_);

      selectedSquareId = feature.values_.id;
      this.getRealEstates(feature.values_.id);

      return selected;
    },
    showCity() {
      this.$store.dispatch('fetchCity', this.city.id).then((response) => {
        map.getView().setZoom(12);
        map.getView().setCenter(transform([response.lng, response.lat], 'EPSG:4326', projection));
      });
    },
    loadSquares() {
      var This = this;

      var industryId = this.$store.state.quiz.industry == null ? 0 : this.$store.state.quiz.industry;

      this.getScoring(industryId).then(() => {

          This.$store.dispatch('fetchSquares', {'cityId': This.city.id}).then((response) => {
            map.removeLayer(layer);

            This.geoJson = response;
            This.squares = response;

            source = new VectorSource({
              features: new GeoJSON().readFeatures(This.geoJson),
            });

            layer = new VectorLayer({
              name: 'grid-layer',
              renderMode: 'image',
              source: source,
              maxZoom: 18,
              style: function (feature) {
                // console.log('feature', feature, This.scoring[feature.values_.externalId]);
                if(This.featuresStylesIndexes[feature.values_.id] != undefined) {

                  if(selectedSquareId != null) {
                    if(feature.values_.id == selectedSquareId) {
                      return This.selectStyle(feature);
                    }
                  }

                  // console.log('This.stylesObjects[feature.values_.id]',This.stylesObjects[feature.values_.id]);
                  return This.stylesObjects[This.featuresStylesIndexes[feature.values_.id]];
                  //return new Style(This.styles[This.featuresStylesIndexes[feature.values_.id]]);
                } else {

                  var idx = This.scoring[feature.values_.externalId+""] - 1;//This.getSquareStyleIndex();

                  This.featuresStylesIndexes[feature.values_.externalId] = idx;

                  if(selectedSquareId != null) {
                    if(feature.values_.id == selectedSquareId) {
                      return This.selectStyle(feature);
                    }
                  }
                  // console.log('This.stylesObjects[idx]',This.stylesObjects[idx].getText().setText(idx));
                  return This.stylesObjects[idx];// new Style(This.styles[idx]);
                }

              }
            });

            layer.setZIndex(100);


            map.addLayer(layer);
            This.squaresLoaded = true;
            This.onMapLoadHandler();
          });
      });

    },
    getTextStyle(feature) {
      // console.log('getTextStyle feature', feature, 'textStyle',textStyle);
      this.textStyle.getText().setText(this.featuresStylesIndexes[feature.values_.externalId] == undefined ? null : textScores[this.featuresStylesIndexes[feature.values_.externalId]]);
      return this.textStyle;
    },
    loadScoreLabels() {
      var This = this;
      var industryId = this.$store.state.quiz.industry == null ? 0 : this.$store.state.quiz.industry;
      this.getScoring(industryId).then(() => {
          This.$store.dispatch('fetchSquares', {'cityId': This.city.id}).then((response) => {
            map.removeLayer(labelLayer);
            This.geoJson = response;

            // Convert GeoJSON to features
            const labelFeatures = new GeoJSON().readFeatures(This.geoJson, {
              featureProjection: projection
            });

            // Create separate sources
            labelSource = new VectorSource({
              features: labelFeatures
            });

            // Create label features based on polygon centers
            // labelFeatures.forEach(polygon => {
            //   const geometry = polygon.getGeometry();
            //   const center = geometry.getInteriorPoint(); // Better than centroid for complex polygons
            //   // add scoring to polygons
            //   if (This.scoring[polygon.values_.externalId]) {
            //     polygon.values_.score_ = This.scoring[polygon.values_.externalId];
            //     polygon.score = This.scoring[polygon.values_.externalId];
            //   }
            //   const score = polygon.score;
            //   const labelFeature = new Feature({
            //     geometry: new Point(center.getCoordinates()),
            //     score
            //   });
            //   labelSource.addFeature(labelFeature);
            // });
            // Label layer
            labelLayer = new VectorLayer({
              name: 'score-layer',
              renderMode: 'image',
              source: labelSource,
              maxZoom: 18,
              style: function (feature) {
                // console.log('style feature', feature);
                if (This.scoring[feature.values_.externalId]) {
                  feature.values_.score_ = This.scoring[feature.values_.externalId];
                  feature.score = This.scoring[feature.values_.externalId];
                }
                
                if(This.featuresStylesIndexes[feature.values_.id] != undefined) {
                  console.log('This.featuresStylesIndexes[feature.values_.id]',feature.values_.id,This.featuresStylesIndexes[feature.values_.id],);
                  
                  if(selectedSquareId != null) {
                    if(feature.values_.id == selectedSquareId) {
                      return This.getTextStyle(feature);
                    }
                  }
                  return This.stylesLabelsObjects[This.featuresStylesIndexes[feature.values_.id]];
                } else {
                  var idx = This.scoring[feature.values_.externalId+""] - 1;
                  This.featuresStylesIndexes[feature.values_.externalId] = idx;
                  if(selectedSquareId != null) {
                    if(feature.values_.id == selectedSquareId) {
                      return This.getTextStyle(feature);
                    }
                  }
                  return This.stylesLabelsObjects[idx];
                }
              }
            });

            // console.log('labelLayer',labelLayer);
            // labelLayer.setZIndex(10000);
            if(this.$props['scoringShouldBeShown']) {
              map.addLayer(labelLayer);
              // console.log('scoringShouldBeShown', this.$props['scoringShouldBeShown']);
            }
            var zIndex = 1;
            map.getLayers().forEach(function(layer) {
              layer.setZIndex(zIndex);
            });
            labelLayer.setZIndex(10001);
            This.onMapLoadHandler();
          });
      });
    },
    zoomChangeHandler() {
      var rawFontSize = map.getView().getZoom() * 1.2 + 10;
      // var rawFontSize = map.getView().getZoom() * 10;
      var min = 30;
      var max = 42;
      this.fontSize = Math.max(min, Math.min(max, rawFontSize));
      // this.loadScoreLabels();
      console.log('zoomChangeHandler', this.fontSize, map.getView().getZoom());
    },
    selectSquare() {
      var This = this;
      var mapSize = map.getSize();
      map.forEachFeatureAtPixel([mapSize[0]/2, mapSize[1]/2], function(feature, layer) {
        if(layer.values_.name !== 'grid-layer') return;
        if (feature) {

          clearInterval(mapLoadedHandlerInterval);
          var featureExtent = feature.getGeometry().getExtent();
          var featureCenter = getCenter(featureExtent);
          map.getView().setCenter([featureCenter[0], featureCenter[1]]);//centering to center of selected square

          map.getView().fit(featureExtent);


          selectedSquareId = feature.values_.id;
          //This.selectStyle(feature);//this shows real estate offers
          This.$emit('square-selected', feature.values_);
          //symulowanie kliku po załadowaniu się mapy
          simulateClickEvent(mapSize[0]/2, mapSize[1]/2);

          This.mapLoaded = true;

        }
      });
    },
    getSquareStyleIndex() {
      return Math.floor(Math.random() * colors.length);
    },
    reportMarkerClick() {

      var clickInfoObject = {
        "ctaName" : " Place_Icon",
        "ctaType" : "Icon",
        "ctaLocation" : "Map",
      };

      window.adobeDataLayer.push({ "event" : "ctaClick",
        "clickInfo" : clickInfoObject});

    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    },
    changJsonToFeaturLayer(jsonFeature, cb) {
      var geojsonFormat = new GeoJSON();
      var features = geojsonFormat.readFeatures(jsonFeature);
      cb(features)
    },
    selectCurrentSquare(ix) {
      var This = this;
      var minScor = Math.min(...Object.values(this.scoring));
      var maxScore = Math.max(...Object.values(this.scoring));
      // select all areas in current location that score is > maxScore - minScore
      var hightScore = Object.keys(this.scoring).reduce((p,c) => {
        if (this.scoring[c] > (maxScore - minScor)) {
          p[c] = this.scoring[c];
        }
        return p;
      }, {});
      
      // get only ids from highscores
      var hightScoreIds = Object.keys(hightScore);
      This.maxSquareId = hightScoreIds.length;
      // get all features from curent location
      var tempFeatures = this.squares.features;

      // find polygon with hightscore by the idx
      var currentSquare = tempFeatures.find((el) => {
        if (ix > This.maxSquareId) {
          return el.properties.externalId == hightScoreIds[(This.maxSquareId - 1)]
        } else {
          return el.properties.externalId == hightScoreIds[ix]
        }
      });
      console.log('currentSquare', currentSquare);
      

      var mapSize = map.getSize();
      this.changJsonToFeaturLayer(currentSquare, (feat) => {
        const extent = feat[0].getGeometry().getExtent();
        const center = getCenter(extent);
        map.getView().setCenter([center[0], center[1]]);//centering to center of selected square
        selectedSquareId = feat[0].values_.id;

        map.getView().fit(extent);
        setTimeout(function(){
          This.$emit('square-selected', feat[0].values_);
          simulateClickEvent(mapSize[0]/2, mapSize[1]/2);
          This.mapLoaded = true;
        },100)
      });
      // console.log('first', hightScoreIds[0], currentSquare);
      // console.log('select square ix', ix, currentSquare, hightScoreIds[ix], );
    },
    selectSquareById(ix) {
      var This = this;
      var mapSize = map.getSize();
      var tempScoringIds = Object.keys(this.scoring);
      var tempSquareInScoring = tempScoringIds.find(e => e == ix);
      var tempFeature = this.squares.features.find(e => e.properties.externalId == ix);
      // console.log('selectSquareById', ix, tempScoringIds, tempSquareInScoring, tempFeature);

      if (tempSquareInScoring && tempFeature) {
        this.changJsonToFeaturLayer(tempFeature, (feat) => {
          const extent = feat[0].getGeometry().getExtent();
          const center = getCenter(extent);
          map.getView().setCenter([center[0], center[1]]);//centering to center of selected square
          selectedSquareId = feat[0].values_.id;

          map.getView().fit(extent);
          setTimeout(function(){
            This.$emit('square-selected', feat[0].values_);
            simulateClickEvent(mapSize[0]/2, mapSize[1]/2);
            This.mapLoaded = true;
          },100)
        });
      }
    },
    selectNextSquare() {
      if (this.tempSquareId < (this.maxSquareId - 1)) {
        this.tempSquareId += 1;
      } else {
        // this.tempSquareId = (this.maxSquareId - 1);
        this.tempSquareId = 0;
      }
      // console.log('selectNextSquare', this.tempSquareId, this.maxSquareId);
      this.selectCurrentSquare(this.tempSquareId);
    },
    selectPrevSquare() {
      if (this.tempSquareId > 0) {
        if (this.tempSquareId < this.maxSquareId) {
          this.tempSquareId -= 1;
        } else {
          this.tempSquareId = this.maxSquareId - 2;
        }
      } else {
        // this.tempSquareId = 0;
        this.tempSquareId = (this.maxSquareId - 1);
      }
      // console.log('selectPrevSquare', this.tempSquareId, this.maxSquareId);
      this.selectCurrentSquare(this.tempSquareId);
    },
  }
};
export default MapWidget;
</script>